var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "article",
      class: [
        _vm.size ? "article-" + _vm.size : "",
        { "not-subscribe": _vm.notSubscribe },
      ],
    },
    [
      _vm.tags
        ? _c(
            "div",
            { staticClass: "article__tags" },
            [
              _vm.classification
                ? _c("Tag", {
                    class: _vm.setTagColour(_vm.classification),
                    attrs: {
                      text: _vm.classification,
                      color: "green",
                      background: "gray",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm.tags.filter((item, index) => index < 3),
                function (tag, index) {
                  return _c("Tag", {
                    key: index,
                    class:
                      _vm.watchlistTags &&
                      _vm.watchlistTags.find((el) => tag.tid === el)
                        ? "brightblue"
                        : null,
                    attrs: {
                      text: tag.title,
                      color: "brightblue",
                      background: "gray",
                      link: _vm.setTagURL(tag),
                      uuid: tag.uuid,
                      tid: tag.tid,
                    },
                  })
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "article-bottom" }, [
        _vm.download
          ? _c(
              "div",
              { staticClass: "article__download" },
              [_c("Download", { attrs: { file: _vm.download } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.file
        ? _c(
            "div",
            { staticClass: "article__title" },
            [
              _c("nuxt-link", {
                staticClass: "article__title-link",
                attrs: {
                  to: _vm.link,
                  target: _vm.newTab ? "_blank" : "_self",
                },
                domProps: { innerHTML: _vm._s(_vm.title) },
              }),
            ],
            1
          )
        : _c("div", [
            _c("a", {
              staticClass: "article__title-link",
              attrs: { href: _vm.file },
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
          ]),
      _vm._v(" "),
      _vm.desc && _vm.hasAccess
        ? _c("div", {
            staticClass: "article__desc",
            domProps: { innerHTML: _vm._s(_vm.desc) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.desc && !_vm.hasAccess
        ? _c("div", { staticClass: "article__desc unauthorised" }, [
            _vm._v("\n    " + _vm._s(_vm.noAccessShort) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.date
        ? _c(
            "div",
            { staticClass: "article__date" },
            [_c("Date", { attrs: { text: _vm.date, author: _vm.author } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }